import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, timeout: 15000 });

const IMG = "https://image.tmdb.org/t/p";
export const FALLBACK_POSTER = "/fallback-poster.svg";
export const FALLBACK_BACKDROP = "/fallback-backdrop.svg";

export const posterUrl = (p, size = "w342") => (p ? `${IMG}/${size}${p}` : FALLBACK_POSTER);
export const backdropUrl = (p, size = "w1280") => (p ? `${IMG}/${size}${p}` : FALLBACK_BACKDROP);
export const profileUrl = (p) => (p ? `${IMG}/w185${p}` : FALLBACK_POSTER);

export const year = (d) => (d ? d.slice(0, 4) : "—");

export const errorMessage = (e) =>
  e?.response?.data?.error || "Something went wrong while loading movies.";
